module.exports = __webpack_public_path__ + "static/media/ic_why_hs_gmc_1.30f9ee8a.svg";